module.exports = __webpack_public_path__ + "chart-sprites.35c4b18ca7a7d028cdfc.png";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/spreadsheet/chart-sprites.png
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/spreadsheet/chart-sprites.png
// module chunks = 2